// extracted by mini-css-extract-plugin
export default {"badge":"BadgeDark__badge___2L2RB BadgeLight__badge___dmf2u"};